<template>
	<v-dialog
		v-model="localShowDialog"
		:width="$vuetify.display.mobile ? '95%' : '500px'"
		:persistent="buttonIsLoading"
		@click:outside="handleDismiss"
		@keydown.esc="handleDismiss"
	>
		<v-card data-test="remove-task-dialog">
			<v-card-title class="dialog-header sgnl-subtitle-medium"> Delete Task? </v-card-title>
			<v-divider />
			<v-card-text class="dialog-body">
				<p class="sgnl-paragraph-m-regular sgnl-text-color-secondary">
					Would you like to permanently delete task
					<code
						class="sgnl-code-default"
						v-if="taskID != null"
						data-test="task-card-task-id-value"
						>{{ taskID }}</code
					>?
				</p>
				<v-alert
					:icon="false"
					class="sgnl-paragraph-s-regular"
					type="warning"
					variant="outlined"
					elevation="0"
				>
					<strong>This operation can not be undone.</strong>
				</v-alert>
				<v-alert
					v-if="showSupportMessage"
					:icon="false"
					border="start"
					class="sgnl-paragraph-s-regular"
					type="warning"
					variant="outlined"
					elevation="0"
				>
					{{ getSupportMessage }}
				</v-alert>
			</v-card-text>
			<v-divider />
			<v-card-actions class="dialog-footer">
				<v-btn
					variant="outlined"
					@click="handleDismiss"
				>
					Cancel
				</v-btn>
				<v-btn
					variant="flat"
					color="error"
					:loading="buttonIsLoading"
					@click="removeTask"
					data-test="task-remove-button"
				>
					Delete Task
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import { sdk } from "@/js/sdk";
import { useTasksStore } from "@/stores/tasks";

const SupportMessage = `Could not remove this item.\n If this issue persists, please contact Signaloid Support at\n developer-support@signaloid.com. `;

export default defineComponent({
	name: "TasksRemoveDialog",
	emits: ["update:showDialog", "removeTaskSuccess", "closeRemoveTaskDialog"],
	data: () => ({
		buttonIsLoading: false,
		showSupportMessage: false,
	}),
	props: {
		showDialog: { type: Boolean, default: false },
		taskID: {
			type: String,
			default: null,
		},
	},
	computed: {
		localShowDialog: {
			get() {
				return this.showDialog;
			},
			set(value) {
				this.$emit("update:showDialog", value);
			},
		},
		getSupportMessage() {
			return SupportMessage;
		},
	},
	setup() {
		const tasksStore = useTasksStore();
		return {
			tasksStore,
		};
	},
	methods: {
		async removeTask() {
			this.buttonIsLoading = true;
			try {
				await sdk.tasks.deleteOne(this.$props.taskID);

				this.buttonIsLoading = false;
				this.closeDialog();
				this.tasksStore.removeTaskByIdFromLocal(this.$props.taskID);
				this.$emit("removeTaskSuccess");
			} catch {
				this.buttonIsLoading = false;
				this.showSupportMessage = true;
			}
		},
		handleDismiss() {
			if (this.buttonIsLoading) {
				return;
			}
			this.closeDialog();
		},
		closeDialog() {
			this.$emit("closeRemoveTaskDialog");
		},
	},
});
</script>
